import { useState,useEffect } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Radio, Space, Spin, Table, Tabs, Tag, Checkbox } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Box, Typography } from '@mui/material';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
//import Demand from '../../../Models/Banque';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

import CheckStan from "../../Prints/CheckStan";

import { fetchDataTable, fetchDataTable2 } from "../../../utilitaires/globalFunction";
import User from "../ManageUser/User";
//import Banque from "../../../Models/Banque";
import {IParametreBDC} from "../../../dataTypes/GlobalDataType";


const ParamBDC = () => {

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [Idbutton, setIdbutton] = useState(false);
    const [Idlibell, setIdlibell] = useState(true);
    const [DataBranch, SetDataBranch] = useState<IParametreBDC[]>([]);
    const [currentDataBranch, setCurrentDataBranch] = useState<IParametreBDC | null>(null);
    const [plansAutorises, setPlansAutorises] = useState<{ IDPLAN: string; LIBELL?: string }[]>([]);
      

     const [error, setError] = useState<string | null>(null);
          const [loading2, setLoading2] = useState(false);
       
    //const [billetages, setBilletages] = useState<Lib[]>([]);
   
   const dataOption2: DataSelect[] = [
  { label: "BDC--BON DE CAISSE", value: "BDC" },
  { label: "DAT--DEPOT A TERME", value: "DAT" }
]

  const dataOption3: DataSelect[] = [
  { label: "PRE--BON DE CAISSE PRECOMPTE", value: "PRE" },
  { label: "POST--BON DE CAISSE POSTCOMPTE", value: "POST" }
]

  const dataOption4: DataSelect[] = [
  { label: "N--NON", value: "N" },
  { label: "O--OUI", value: "O" }
]

  const dataOptionMoe: DataSelect[] = [
  { label: "C--À LA MISE EN PLACE", value: "C" },
  { label: "V--À LA VALIDATION", value: "V" }
]

  // Mode des intérêts en interruption du contrat
  const dataOptionModeAnticip: DataSelect[] = [
  { label: "NON--LA BANQUE REPREND TOUT", value: "NON" },
  { label: "ACQ--LE CLIENT GARDE LES INTÉRÊTS DES JOURS ÉCOULÉS", value: "ACQ" }
]

    //pour les agences
let searchBDC: ParamsPicklist = { CodeAgence: Perss.codage, Table: "PARAMBDC", Colonne1: "CODBDC", Colonne2: "LIBELL", Colagence: 'CODAGE', Choix: 1 }
let searchFreq: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", colfiltre:"RUBRIQ",valfiltre:'PERIOD', Choix: 22 }

//pour les plans comptables autorisés
let searchPlancp: ParamsPicklist = { CodeAgence: '', Table: "PLANCP", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: '', Choix: 22 }

//pour le code opération des frais de souscription (grille tarifaire)
let searchCodOpe: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '', Choix: 22 }
// Libellés de documents d'interruption — liste LIB (RUBRIQ='DOCINTER')
let searchDocReq: ParamsPicklist = { CodeAgence: 'DOCINTER', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }

//pour les Comptes
let searchVille: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", colfiltre:"RUBRIQ",valfiltre:'PERIOD', Choix: 22 }

//pour les COMPTES
let searchComptes: ParamsPicklist = { CodeAgence: Perss.codage, Table: "Comptes", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: 'AGCCPT', Choix: 22 }

//let searchRegion: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", colfiltre:"RUBRIQ",valfiltre:'REGION', Choix: 22  }

useEffect(() => {
    loadAllDataBranch();
}, []);

    // Handle function
    function HandleConsult() {
        setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false)
        setIdbutton(true)
    }

    function HandleAjout() {
        HandleAnnul();
        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add');
        setIdlibell(false);
        
    }

    function HandleModif() {
        setAjoute(true)
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false)
        setFormactve(false);
        setSbmit('modif');
        setSupprime(true);
        setIdbutton(true);
        setIdlibell(false);
    }

    function HandleSupp() {
        setSbmit('supp');
    }

    function HandleAnnul() {

        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        form.resetFields();
        setFormactve(true);
        setSbmit('');
        setIdlibell(true);
        setIdbutton(false)
        setPlansAutorises([])
        setGrilleInfo({})
    }
    // Contrôle immédiat de la grille tarifaire d'un code opération de frais
    // (souscription / interruption) : CODOPE -> OPERAT.CODTARIF ->
    // TARIFICATION + comptes de contrepartie. Code sans grille -> alerte et
    // champ vidé (l'enregistrement est de toute façon bloqué par le serveur).
    const [grilleInfo, setGrilleInfo] = useState<Record<string, { ok: boolean; texte: string }>>({});

    const controleGrille = async (champ: 'CODOPEFRAIS' | 'CODOPEPENAL', alerte = true) => {
        const code = String(form.getFieldValue(champ) || '').trim();
        if (!code) { setGrilleInfo(prev => ({ ...prev, [champ]: { ok: true, texte: '' } })); return; }
        const libelle = champ === 'CODOPEFRAIS' ? 'Frais de souscription' : "Pénalité d'interruption";
        try {
            const response = await axios({
                method: 'get',
                url: Data.ApiUrl.ControleGrilleFraisBDC,
                headers: {
                    'CypherCodOpe': Crypter.encrypt(JSON.stringify(code)),
                    'CypherAgence': Crypter.encrypt(JSON.stringify(Perss.codage)),
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                }
            });
            const res = response.data ? JSON.parse(Crypter.decrypt(response.data)) : null;
            if (res?.StatutCode != 200) throw new Error(res?.Message || 'contrôle indisponible');
            const erreur = res.Result?.Table?.[0]?.ERREUR;
            const codTarif = res.Result?.Table?.[0]?.CODTARIF;
            const paliers: any[] = res.Result?.Table1 || [];
            if (erreur) {
                setGrilleInfo(prev => ({ ...prev, [champ]: { ok: false, texte: erreur } }));
                if (alerte) {
                    form.setFieldValue(champ, '');
                    form.setFieldValue('lib_' + champ, '');
                }
                SweetAlert.fire({ icon: 'warning', title: `${libelle} : grille tarifaire invalide`, text: `${erreur}${alerte ? ' Le code a été retiré.' : ''}` });
                return;
            }
            const bornes = paliers.map((p: any) => `${Number(p.BORNEINF).toLocaleString('fr-FR')} → ${p.BORNESUP == null ? '∞' : Number(p.BORNESUP).toLocaleString('fr-FR')}`).join(' | ');
            setGrilleInfo(prev => ({ ...prev, [champ]: { ok: true, texte: `Grille ${codTarif} — ${paliers.length} palier(s) : ${bornes}` } }));
        } catch (err: any) {
            setGrilleInfo(prev => ({ ...prev, [champ]: { ok: false, texte: 'Contrôle de la grille indisponible : ' + (err?.message || err) } }));
        }
    };

    const infoGrille = (champ: string) => grilleInfo[champ]?.texte ? (
        <div style={{ fontSize: 11, marginTop: -4, marginBottom: 6, color: grilleInfo[champ].ok ? '#116599' : '#d4380d' }}>
            {grilleInfo[champ].texte}
        </div>
    ) : null;

    // Documents requis pour l'interruption (DOCREQINTERBDC) — même
    // logique que Safe Care : libellés piochés dans LIB 'DOCINTER'
    const [docRequis, setDocRequis] = useState<any[]>([]);
    const [docOblig, setDocOblig] = useState<boolean>(false);

    const fetchDocRequis = async (codbdc: string) => {
        if (!codbdc) { setDocRequis([]); return; }
        try {
            var params = { CodeAgence: Perss.codage, Table: "DOCREQINTERBDC", Colonne1: "IDREQ", Colonne2: "LIBDOC", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }
            const res = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
            setDocRequis((res || []).filter((p: any) => p.CODBDC === codbdc))
        } catch (err) {
            console.error("Erreur chargement documents:", err);
        }
    };

    const addDocRequis = async () => {
        const codbdc = form.getFieldValue("CODBDC");
        const libdoc = form.getFieldValue('lib_DOCLIB') || form.getFieldValue('DOCLIB');
        if (!codbdc || !libdoc) {
            SweetAlert.fire({ title: "Sélectionnez un libellé de document dans la picklist.", icon: "warning" });
            return;
        }
        if (docRequis.some((d: any) => d.LIBDOC === libdoc)) {
            SweetAlert.fire({ title: "Ce libellé est déjà dans la liste.", icon: "warning" });
            return;
        }
        try {
            const payload = { TYPBDC: codbdc, LIBDOC: libdoc, OBLIGATOIRE: docOblig ? 'O' : 'N', CODAGE: Perss.codage, UTISAI: Perss.coduti };
            const data = Crypter.encrypt(JSON.stringify(payload));
            const res = await axios.request({
                method: 'post',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.AddDocRequisInterruptionBDC,
                headers: {
                    'CypherDoc': data,
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                }
            });
            if (res.data) {
                const r = JSON.parse(Crypter.decrypt(res.data));
                if (r.StatutCode != 200) {
                    SweetAlert.fire({ title: "Warning", text: r.Message, icon: "warning" })
                }
            }
            form.setFieldValue('DOCLIB', '');
            form.setFieldValue('lib_DOCLIB', '');
            setDocOblig(false);
            fetchDocRequis(codbdc);
        } catch (err) {
            console.error("Erreur document:", err);
        }
    };

    const deleteDocRequis = async (idreq: number) => {
        const codbdc = form.getFieldValue("CODBDC");
        try {
            const payload = { IDREQ: idreq, CODAGE: Perss.codage };
            const data = Crypter.encrypt(JSON.stringify(payload));
            const res = await axios.request({
                method: 'post',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.DeleteDocRequisInterruptionBDC,
                headers: {
                    'CypherDoc': data,
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                }
            });
            if (res.data) {
                const r = JSON.parse(Crypter.decrypt(res.data));
                if (r.StatutCode != 200) {
                    SweetAlert.fire({ title: "Warning", text: r.Message, icon: "warning" })
                }
            }
            fetchDocRequis(codbdc);
        } catch (err) {
            console.error("Erreur document:", err);
        }
    };

    // Plans comptables autorisés (comptes dépôt / intérêts du client)
    const fetchPlans = async (codbdc: string) => {
        if (!codbdc) { setPlansAutorises([]); return; }
        try {
            var params = { CodeAgence: Perss.codage, Table: "PARAMBDC_PLANS", Colonne1: "IDPLAN", Colonne2: "LIBELL", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }
            const res = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
            // Filtre JS sur le type — le filtre SQL n'est pas fiable en choix 32
            setPlansAutorises((res || []).filter((p: any) => p.CODBDC === codbdc))
        } catch (err) {
            console.error("Erreur chargement plans:", err);
        }
    };

    const savePlan = async (action: 'add' | 'del', idplan: string, libell?: string) => {
        const codbdc = form.getFieldValue("CODBDC");
        if (!codbdc || !idplan) return;
        try {
            const payload = { CODBDC: codbdc, CODAGE: Perss.codage, IDPLAN: idplan, LIBELL: libell ?? '', UTILIS: Perss.coduti };
            const data = Crypter.encrypt(JSON.stringify(payload));
            const res = await axios.request({
                method: 'post',
                maxBodyLength: Infinity,
                url: action === 'add' ? Data.ApiUrl.CreateParamBDCPlan : Data.ApiUrl.DeleteParamBDCPlan,
                headers: {
                    'CypherParamBDCPlan': data,
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                }
            });
            if (res.data) {
                const r = JSON.parse(Crypter.decrypt(res.data));
                if (r.StatutCode != 200) {
                    SweetAlert.fire({ title: "Warning", text: r.Message, icon: "warning" })
                }
            }
            fetchPlans(codbdc);
        } catch (err) {
            console.error("Erreur plan:", err);
        }
    };

    // Ajout d'un plan : picklist PLANCP → tag fermable (style Safe Care)
    const handleAddPlan = () => {
        const id = form.getFieldValue('PLANAUTORISE');
        const lib = form.getFieldValue('lib_PLANAUTORISE') ?? id;
        if (!id) { SweetAlert.fire({ title: 'Attention', text: 'Sélectionnez un plan.', icon: 'warning' }); return; }
        if (plansAutorises.some(p => p.IDPLAN === id)) { SweetAlert.fire({ title: 'Attention', text: 'Plan déjà autorisé.', icon: 'warning' }); return; }
        // Affiche le tag immédiatement, puis persiste et recharge
        setPlansAutorises(prev => [...prev, { IDPLAN: id, LIBELL: lib }]);
        savePlan('add', id, lib);
        form.setFieldValue('PLANAUTORISE', undefined);
        form.setFieldValue('lib_PLANAUTORISE', undefined);
    };

    async function loadAllDataBranch() {
      
         setLoading2(true);
        setError(null);
        try {
     // console.log(apiEndpoints.bureaux)
      var params = { CodeAgence: Perss.codage , Table: "PARAMBDC", Colonne1: "CODBDC", Colonne2: "LIBELL", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }

      const data = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
      SetDataBranch(data || []);
      return data
      }catch (err) {
      console.error("Erreur de chargement:", err);
      setError("Impossible de charger les données .");
      return []
     } finally {
      setLoading2(false);
     }
    }

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Type bon de caisse
                </span>
            ),
            children: <>
                <div className='tabItem' >
                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  sx={{p:1}}>
                            <legend> Pramètres bon de caisse </legend>

                            <Box display={"flex"} fontStyle="inherit" className='border-left'>

                                {/* Colonne 1 — Identification */}
                                <Box fontStyle="inherit" className='border-left' style={{ flex: 1 }}>
                                    <SearInputG enable notremove notRequired dissabledCode={Idbutton} dissabledLib={Idlibell} width={7} form={form} Titre='Recherche type de bon' label='Code' name='CODBDC' Parametre={searchBDC} />
                                    <SelectOption notRequired width={11} Size='small' name="TYPBDC" Option={dataOption2} label="Type de bon" disabled={Idlibell} />
                                    <SelectOption notRequired width={11} Size='small' name="TYPIMPUTINT" Option={dataOption3} label="Type imputation" disabled={Idlibell} />
                                    <SearchModal notremove disabled={Idlibell} width={11} Taille1="35%" Taille2="65%" form={form} Titre='Recherche périodicité' label='Fréquence' name='FREQPROV' Parametre={searchFreq} />
                                    <InputForm width={11} label='Durée' name='DUREE' type='number' />
                                    <SearchModal notremove disabled={Idlibell} width={11} Taille1="35%" Taille2="65%" form={form} Titre='Recherche plan comptable' label='Plan cpt compte BDC' name='PLANCPTBDC' Parametre={searchPlancp} />
                                    <SearchModal notremove disabled={Idlibell} width={11} Taille1="35%" Taille2="65%" form={form} Titre='Recherche compte' label='Compte taxe crédit' name='CPTTAXECRE' Parametre={searchComptes} />
                                    <InputForm width={11} label='Libellé taxe crédit' name='LIBTAXECRE' type='text' notRequired />
                                    {/* Plans comptables autorisés (dépôt / intérêts) — style Safe Care */}
                                    <Box>
                                        <SearchModal notremove notRequired disabled={Idlibell && sbmit !== 'modif'} width={11} Taille1="35%" Taille2="65%" form={form} Titre='Recherche plan comptable' label='Plan comptable dépôt/intérêt' name='PLANAUTORISE' Parametre={searchPlancp} />
                                        <Button size="small" type="dashed" disabled={Idlibell && sbmit !== 'modif'} onClick={handleAddPlan} style={{ marginBottom: 6 }}>+ Ajouter le plan</Button>
                                        <Box>
                                            {plansAutorises.map((p, i) => (
                                                <Tag
                                                    key={i}
                                                    closable={!(Idlibell && sbmit !== 'modif')}
                                                    onClose={() => {
                                                        setPlansAutorises(prev => prev.filter(pl => pl.IDPLAN !== p.IDPLAN));
                                                        savePlan('del', p.IDPLAN);
                                                    }}
                                                    style={{ marginBottom: 4 }}
                                                >
                                                    {p.IDPLAN} — {p.LIBELL || ''}
                                                </Tag>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>

                                {/* Colonne 2 — Conditions */}
                                <Box fontStyle="inherit" className='border-left' style={{ flex: 1 }}>
                                    <InputForm width={11} label='Taux intérêt max' name='TXINT' type='number' />
                                    {/* TXPENALITE retiré — champ mort : l'ancienne colonne
                                        n'est utilisée par aucune écriture ; le taux de
                                        pénalité actif est TXPENALINTERUPT (onglet 2) */}
                                    <InputForm width={11} label='Taux taxe' name='TXTAXE' type='number' />
                                    <SelectOption width={11} Size='small' name="AUTOCPTBDC" Option={dataOption4} label="Compte BDC automatique" DefaulValue="N" disabled={Idlibell} notRequired />
                                    <SelectOption width={11} Size='small' name="MOECPTBDC" Option={dataOptionMoe} label="Moment génération compte" DefaulValue="V" disabled={Idlibell} notRequired />
                                    <SelectOption width={11} Size='small' name="MOEFRAIS" Option={dataOptionMoe} label="Moment frais souscription" DefaulValue="V" disabled={Idlibell} notRequired />
                                    <SearchModal notremove disabled={Idlibell} width={11} Taille1="35%" Taille2="65%" form={form} Titre='Recherche code opération' label='Frais souscription' name='CODOPEFRAIS' Parametre={searchCodOpe}
                                        ExecuteafterSelect1={() => controleGrille('CODOPEFRAIS')} />
                                    {infoGrille('CODOPEFRAIS')}
                                </Box>

                                {/* Colonne 3 — Comptes imputation intérêts/provision/taxes */}
                                <Box fontStyle="inherit" className='border-left' style={{ flex: 1 }}>
                                    <SearchModal notremove disabled={Idlibell} width={11} Taille1="35%" Taille2="65%" form={form} Titre='Recherche compte' label='Compte de charge interets' name='CPTINT' Parametre={searchComptes} />
                                    <InputForm width={11} label='Libellé débit intérêt' name='LIBINTDEB' type='text' notRequired />
                                    <SearchModal notremove disabled={Idlibell} width={11} Taille1="35%" Taille2="65%" form={form} Titre='Recherche compte' label='Compte provision/contrepartie' name='CPTPROV' Parametre={searchComptes}
                                        ExecuteafterSelect1={() => {
                                            /* La provision ne se solde à zéro que si le compte taxe
                                               débit est le MÊME compte — on le propose/verrouille */
                                            form.setFieldValue('CPTTAXEDEB', form.getFieldValue('CPTPROV'));
                                            form.setFieldValue('lib_CPTTAXEDEB', form.getFieldValue('lib_CPTPROV'));
                                        }} />
                                    <InputForm width={11} label='Libellé provision crédit' name='LIBPROVCRE' type='text' notRequired />
                                    <SearchModal notremove disabled width={11} Taille1="35%" Taille2="65%" form={form} Titre='Recherche compte' label='Compte taxe débit' name='CPTTAXEDEB' Parametre={searchComptes} />
                                    <InputForm width={11} label='Libellé taxe débit' name='LIBTAXEDEB' type='text' notRequired />
                                    <SearchModal notremove disabled={Idlibell} width={11} Taille1="35%" Taille2="65%" form={form} Titre='Recherche compte' label='Compte pénalité' name='CPTPENALITE' Parametre={searchComptes} />
                                    <InputForm width={11} label='Libellé pénalité' name='LIBPENALITE' type='text' notRequired />
                                    <SearchModal notremove disabled={Idlibell} width={11} Taille1="35%" Taille2="65%" form={form} Titre='Recherche compte' label='Compte taxe sur pénalité' name='CPTTAXEPENALITE' Parametre={searchComptes} />
                                    <InputForm width={11} label='Libellé taxe sur pénalité' name='LIBTAXEPENALITE' type='text' notRequired />
                                </Box>
                            </Box>

                        </Box>
                    </div>
                </div >
            </>,
        },
        {
            key: '2',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Paramètre interruption
                </span>
            ),
            children: <>
                <div className='tabItem' >
                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  sx={{p:1}}>
                            <legend> Paramètre interruption du contrat </legend>

                            <Box display={"flex"} fontStyle="inherit" className='border-left'>

                                {/* Colonne 1 — Conditions d'interruption */}
                                <Box fontStyle="inherit" className='border-left' style={{ flex: 1 }}>
                                    <SelectOption notRequired width={11} Size='small' name="INTERRUPTION" Option={dataOption4} label="Interruption autorisée" DefaulValue="N" disabled={Idlibell} />
                                    <InputForm width={11} label='Durée min avant interruption (jours)' name='DUREEMININTERUPT' type='number' notRequired />
                                    <SelectOption notRequired width={11} Size='small' name="MODEINTINTERUPT" Option={dataOptionModeAnticip} label="Sortie des intérêts" DefaulValue="NON" disabled={Idlibell} />
                                </Box>

                                {/* Colonne 2 — Pénalité via code opération (grille tarifaire) :
                                    base = montant du bon x jours restants / 360 */}
                                <Box fontStyle="inherit" className='border-left' style={{ flex: 1 }}>
                                    <SearchModal notremove disabled={Idlibell} width={11} Taille1="35%" Taille2="65%" form={form} Titre='Recherche code opération' label="Pénalité d'interruption" name='CODOPEPENAL' Parametre={searchCodOpe}
                                        ExecuteafterSelect1={() => controleGrille('CODOPEPENAL')} />
                                    {infoGrille('CODOPEPENAL')}
                                    
                                </Box>

                            </Box>

                            {/* Documents requis pour une interruption —
                                même logique que Safe Care : la picklist
                                pioche le libellé dans LIB (RUBRIQ='DOCINTER')
                                puis « Ajouter » l'enregistre pour ce type. */}
                            <Box fontStyle="inherit" className='border-left bordure1' sx={{ p: 1, mt: 1 }}>
                                <Typography color={"#116599"}><b>Documents nécessaires à l'interruption</b></Typography>
                                <Box display={"flex"} fontStyle="inherit" sx={{ alignItems: 'flex-end', gap: 2 }}>
                                    <SearchModal notremove notRequired disabled={Idlibell} width={6} Taille1="35%" Taille2="65%" form={form} Titre='Recherche document' label='Libellé du document' name='DOCLIB' Parametre={searchDocReq} />
                                    <Checkbox checked={docOblig} onChange={(e) => setDocOblig(e.target.checked)} disabled={Idlibell} style={{ marginBottom: 8 }}>
                                        Obligatoire
                                    </Checkbox>
                                    <Button size='small' className='bt_add' type="ghost" onClick={addDocRequis} disabled={Idlibell || !form.getFieldValue('CODBDC')}>
                                        Ajouter
                                    </Button>
                                </Box>
                                <Table
                                    size='small'
                                    rowKey={(r) => String(r.IDREQ)}
                                    dataSource={docRequis}
                                    pagination={false}
                                    columns={[
                                        { title: 'Libellé du document', dataIndex: 'LIBDOC', key: 'LIBDOC' },
                                        { title: 'Obligatoire', dataIndex: 'OBLIGATOIRE', key: 'OBLIGATOIRE', width: 100, render: (v: any) => v === 'O' ? 'Oui' : 'Non' },
                                        { title: '', key: 'del', width: 60, render: (_, r: any) => (<Button size='small' danger onClick={() => deleteDocRequis(r.IDREQ)}>Retirer</Button>) },
                                    ]}
                                />
                            </Box>

                        </Box>
                    </div>
                </div >
            </>,
        }
    ];

    // function consult — charge le type de BDC dont le code est saisi
    async function consult() {
        const codbdc = form.getFieldValue("CODBDC")
        if (!codbdc) {
            SweetAlert.fire({ title: "Sélectionnez ou saisissez d'abord un code.", icon: "warning" })
            return
        }
        setLoading(true)
        const list = await loadAllDataBranch()
        setLoading(false)
        const row = (list || []).find((c: IParametreBDC) => c.CODBDC === codbdc)
        if (!row) {
            SweetAlert.fire({ title: "Type de bon introuvable", text: "Aucun type trouvé pour le code : " + codbdc, icon: "warning" })
            return
        }
        form.setFieldsValue({ ...row, lib_CODBDC: row.LIBELL })
        setCurrentDataBranch(row)
        fetchPlans(codbdc)
        fetchDocRequis(codbdc)
        // Signale un paramétrage existant dont la grille est invalide
        controleGrille('CODOPEFRAIS', false)
        controleGrille('CODOPEPENAL', false)
        // Active Modifier / Supprimer / Annuler, verrouille le code
        setModife(false)
        setSupprime(false)
        setAnnule(false)
        setAjoute(true)
        setFormactve(true)
        setIdbutton(true)
        setIdlibell(true)
    }

    // function Onfinish
    const onFinish = (values: any) => {

        console.log(values)
        var Demand: IParametreBDC = values

       // Demand.NUMCPT = Demand.NUMBAN
        Demand.DATCRE = formatDate(Perss.datjour)
        //Demand.DATMAJ = formatDate(Perss.datjour)
        Demand.LIBELL = form.getFieldValue("lib_CODBDC")
        Demand.CODAGE = Perss.codage
        Demand.UTISAI = Perss.coduti

      //  alert(Demand.DATMAJ)
     console.log(Demand)

        if (sbmit == "add") {
            SweetAlert.fire({
                title: "Création d'un type de bon de caisse",
                text: "Voulez-vous Créer le type de bon de caisse : " + form.getFieldValue("lib_CODBDC"),
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)

                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.CreateParamBDC,
                        headers: {
                            'CypherParamBDC': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        }
                    };
                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                let code = res.Result
                                //console.log(Demand)

                                if (res.StatutCode == 200) {

                                    if (code == 'Existe') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code existe déja svp choisissez un autre", icon: "warning" })
                                    } else {

                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
        // ********************************************************************************************************************************
        if (sbmit == "modif") {
            SweetAlert.fire({
                title: "Mise à jour type bon de caisse",
                text: "Voulez-vous Mettre à jour La Banque' : " + form.getFieldValue("LIBELL"),
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)

                    let data = Crypter.encrypt(JSON.stringify(Demand));
                    let config = {
                        method: 'put',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.UpdateParamBDC,
                        headers: {
                            'CypherBank': data,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result

                                    if (code == 'INCONNU') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code n'existe pas", icon: "warning" })
                                    } else {

                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }
                                    // setIsSubmit(false)
                                    // HandleAnnul()
                                    // SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
        // ********************************************************************************************************************************
        if (sbmit == "supp") {

            SweetAlert.fire({
                title: "Suppression d'un type de bon de caisse",
                text: "Voulez-vous Supprimer la Banque :" + form.getFieldValue("LIBELL"),
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: "question"
            }).then((res) => {

                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //console.log(JSON.stringify(DemandVP));
                    let data = Crypter.encrypt(JSON.stringify(Demand.CODBDC));
                    let data2 = Crypter.encrypt(JSON.stringify(Demand.CODAGE));
                    let config = {
                        method: 'delete',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.DeleteParamBDC,
                        headers: {
                            'CypherParamBDC': data,
                            'CypherAgence': data2,
                            'Authorization': authHeader(),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                //console.log(res)
                                if (res.StatutCode == 200) {
                                    let code = res.Result

                                    if (code == 'INCONNU') {
                                        SweetAlert.fire({ title: res.Message, text: "Ce code n'existe pas", icon: "warning" })
                                    } else {

                                        //form.resetFields()
                                        //setIsSubmit(false)
                                        HandleAnnul()
                                        SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                    }
                                    // setIsSubmit(false)
                                    // HandleAnnul()
                                    // SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })

                                }
                                else {
                                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                        });
                }
            })
        }
    }

    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult(); }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>
                                    Supprimer
                                </Button>
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );



}

export default ParamBDC;